import { FormikProps, useFormik } from 'formik';
import {
  getAddAdminUserFormValidation,
  getEditAdminUserFormValidation,
} from './FormikData';
import { useTranslation } from 'react-i18next';
import { useGetRoles } from '../../../../services/redux/api/rolesApi';
import { FormikValues } from 'formik/dist/types';
import { usePostPutAdminUser } from '../../../../services/redux/api/usersApi';
import { IUser } from '../../../../types/interfaces/user';

export function useAddAdminUserComponent(onClose: () => void, user?: IUser) {
  const { t } = useTranslation();
  const { data: roles } = useGetRoles();
  const [postPutAdminUser, { isLoading }] = usePostPutAdminUser();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: user?.id
      ? getEditAdminUserFormValidation(t)
      : getAddAdminUserFormValidation(t),
    initialValues: {
      firstname: user?.firstname || '',
      lastname: user?.lastname || '',
      role: user?.role || null,
      email: user?.email || '',
      password: '',
      confirmPassword: '',
      hidden: user?.hidden ?? true,
      active: user?.active ?? true,
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    let body;

    if (user?.id) {
      body = {
        firstname: values.firstname,
        lastname: values.lastname,
        roleId: values.role?.id || null,
        email: values.email,
        hidden: values.hidden,
        active: values.active,
      };
    } else {
      body = {
        firstname: values.firstname,
        lastname: values.lastname,
        email: values.email,
        password: values.password,
        roleId: values.role?.id || null,
        hidden: values.hidden,
      };
    }

    postPutAdminUser({
      id: user?.id,
      body,
    }).then((r) => {
      if (!('error' in r)) {
        onClose();
      }
    });
  }

  return { formik, roles, isLoading };
}
